import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import Drawer from 'components/AntEnhancement/Drawer';
import AccountForm from 'components/forms/accounting/accounts/AccountForm';
import localeTranslator from 'library/Hocs/LocalTranslator';
import { Account } from 'models';
import services from 'services';
import './AccountDrawer.css';
var AccountDrawer = function (props) {
    var visiable = props.visiable, onCloseDrawer = props.onCloseDrawer, t = props.translate;
    var account = useState(function () { return new Account(); })[0];
    var _a = useState(false), saving = _a[0], setSaving = _a[1];
    var form = Form.useForm()[0];
    var accountService = services.accountService, accountTypeService = services.accountTypeService;
    var createAccount = accountService.useCreateAccount().mutate;
    var _b = accountTypeService.useAccountTypes(visiable), accountTypes = _b.data, isLoading = _b.isLoading;
    useEffect(function () {
        if (!visiable)
            return;
        account.setName('');
        account.setAccountTypeId(0);
        form.resetFields();
        setSaving(false);
    }, [visiable, account, form]);
    var onSubmit = function () {
        if (saving)
            return;
        account.setName((account.getName() || '').trim());
        setSaving(true);
        createAccount({ account: account, successMessage: t('messages.accountCreated') }, {
            onSuccess: function () {
                setSaving(false);
                onCloseDrawer();
            },
            onError: function () { return setSaving(false); }
        });
    };
    return (_jsx(Drawer, { title: null, placement: "right", open: visiable, onClose: onCloseDrawer, closable: false, destroyOnClose: true, width: 560, rootClassName: "acct-drawer", className: "acct-drawer", children: _jsxs(Form, { form: form, layout: "vertical", className: "acct-drawer__shell", requiredMark: false, onFinish: onSubmit, onValuesChange: function (changed) {
                var _a;
                if (Object.prototype.hasOwnProperty.call(changed, 'name')) {
                    account.setName(String((_a = changed.name) !== null && _a !== void 0 ? _a : '').trim());
                }
                if (Object.prototype.hasOwnProperty.call(changed, 'account_type_id')) {
                    account.setAccountTypeId(Number(changed.account_type_id));
                }
            }, children: [_jsxs("header", { className: "acct-drawer__header", children: [_jsxs("div", { className: "acct-drawer__title-block", children: [_jsx("span", { className: "acct-drawer__dot", "aria-hidden": true }), _jsxs("div", { children: [_jsx("h2", { className: "acct-drawer__title", children: t('title') }), _jsx("p", { className: "acct-drawer__subtitle", children: t('subtitle') })] })] }), _jsx("button", { type: "button", className: "acct-drawer__close", onClick: onCloseDrawer, "aria-label": t('common:buttons.close'), children: _jsx(CloseOutlined, {}) })] }), _jsx("div", { className: "acct-drawer__body", children: _jsx(AccountForm, { account: account, accountTypes: accountTypes || [] }) }), _jsxs("footer", { className: "acct-drawer__footer", children: [_jsx("button", { type: "button", className: "acct-drawer__btn acct-drawer__btn--ghost", onClick: onCloseDrawer, children: t('common:buttons.cancel') }), _jsxs("button", { type: "submit", className: "acct-drawer__btn acct-drawer__btn--primary", disabled: saving || isLoading, children: [_jsx(CheckOutlined, {}), _jsx("span", { children: saving ? t('saving') : t('submit') })] })] })] }) }));
};
export default localeTranslator(AccountDrawer, 'accountForm');
